'use client';
import * as React from 'react';

import createSvgIcon from './createSvgIcon';

const ChevronUp = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M4.16785 14.9934L11.4897 7.20502C11.6237 7.07405 11.809 7 12.0027 7C12.1963 7 12.3816 7.07405 12.5156 7.20502L19.8341 14.9934C19.9524 15.1182 20.0116 15.2826 19.9981 15.4491C19.9847 15.6155 19.8998 15.7697 19.7628 15.8765L18.5296 16.8488C18.2435 17.0748 17.8168 17.044 17.571 16.7795L12.1283 10.8759C12.0967 10.8415 12.0505 10.8216 12.002 10.8216C11.9535 10.8216 11.9073 10.8415 11.8757 10.8759L6.43093 16.7801C6.31274 16.9066 6.14599 16.9843 5.96698 16.9962C5.78767 17.0112 5.60951 16.9576 5.47304 16.8476L4.23917 15.8765C4.10142 15.7699 4.01577 15.6155 4.00187 15.4487C3.98838 15.282 4.04837 15.1175 4.16785 14.9934Z"
  />,
  'ChevronUp'
);

export default ChevronUp;
